/**
 *
 * WARNING : fichier généré par cli, ne pas le modifier directement
 *
 */
import * as R from 'ramda';
import { useQuery } from '@apollo/client';
import GetSimulationCompanyCcnOfferQuery from '../graphql/queries/GetSimulationCompanyCcnOfferQuery.js';

const useGetSimulationCompanyCcnOfferQuery = (args) => {
  const { data, error, loading, refetch } = useQuery(GetSimulationCompanyCcnOfferQuery, args);

  return {
    error,
    loading,
    refetch,
    getSimulationCompanyCcnOffer: R.omit(['__typename'], data?.getSimulationCompanyCcnOffer_simulation_company || {})
  };
};

export default useGetSimulationCompanyCcnOfferQuery;
